import styled from 'styled-components';

export const CargoTemperatureControlWrapper = styled.div``;

export const CargoTemperatureRow = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
`;
